(function () {
  try {
    const BLOCKED_REFERRERS = [
      'bankofamericalifestylebenefits.com',
      //'linkedin.com',
      'bofa.dev.our-projects.info'
    ];

    const COOKIE_KEY = 'initial_referrer';
    const COOKIE_EXPIRY_MINUTES = 60*24*7; // change as needed

    /* --------------------------
      Cookie helpers
    --------------------------- */
    function setCookie(name, value, minutes) {
      const expires = new Date(Date.now() + minutes * 60 * 1000).toUTCString();
      document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
    }

    function getCookie(name) {
      return document.cookie
        .split('; ')
        .find(row => row.startsWith(name + '='))
        ?.split('=')[1] || '';
    }

    /* --------------------------
      Referrer logic
    --------------------------- */
    let ref = decodeURIComponent(getCookie(COOKIE_KEY));

    // to be removed once testing is done
    // const params = new URLSearchParams(window.location.search);
    // const source = params.get('utm_source');

    // if (source === 'linkedin') {
    //     // suppress popup
    //     ref = 'linkedin.com';
    //     setCookie(COOKIE_KEY, ref, COOKIE_EXPIRY_MINUTES);
    // }
    // to be removed once testing is done till here

    // Store referrer once (cookie)
    if (!ref && document.referrer) {
      setCookie(COOKIE_KEY, document.referrer, COOKIE_EXPIRY_MINUTES);
      ref = document.referrer;
    }

    // Exit if referrer not in blocked list
    if (!ref || !BLOCKED_REFERRERS.some(d => ref.includes(d))) {
      return;
    }

    /* --------------------------
      Close popup / iframe
    --------------------------- */
    function closePopupIfPresent() {
      const closeBtn = document.querySelector('.klaviyo-close-form');
      if (closeBtn) {
        closeBtn.click();
        return true;
      }
      return false;
    }

    function closeIframeIfPresent() {
      const iframe = document.querySelector('#ps__widget_container iframe');
      if (iframe) {
        iframe.remove();
        return true;
      }
      return false;
    }

    // Try immediately
    if (closePopupIfPresent() || closeIframeIfPresent()) return;

    // Observe async loads
    const observer = new MutationObserver(() => {
      if (closePopupIfPresent() || closeIframeIfPresent()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

  } catch (e) {
    console.warn('Popup auto-close error', e);
  }
})();
